import { render, staticRenderFns } from "./go-back-bar.vue?vue&type=template&id=836673c0"
import script from "./go-back-bar.vue?vue&type=script&lang=js"
export * from "./go-back-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports